let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("momKe")).then(() => parcelRequire('csnLw'));